<avi-confirmation
    class="clr-wrapper"
    (onClose)="handleClose()"
    [closeOnBackdropClick]="false"
    [closeOnEscapeKeypress]="true"
    [headerText]="l10nKeys.modalTitle | vtranslate"
    size="xl"
    id="connect-on-prem-modal"
>
    <ng-container ngProjectAs="avi-confirmation_modal-content">
        <div class="connect-on-prem-modal__content">
            <div class="connect-on-prem-modal__steps-container">
                <!-- Step 1: Deploy & Register -->
                <div class="connect-on-prem-modal__step">
                    <div class="connect-on-prem-modal__step-header">
                        <div class="connect-on-prem-modal__step-icon-wrapper">
                            <div class="connect-on-prem-modal__step-icon-line connect-on-prem-modal__step-icon-line--right"></div>
                            <div class="connect-on-prem-modal__step-icon">
                                <img
                                    src="src/img/licensing/assign-user.svg"
                                    alt="{{ l10nKeys.deployRegisterStepTitle | vtranslate }}"
                                    class="connect-on-prem-modal__image"
                                />
                            </div>
                        </div>
                        <p class="connect-on-prem-modal__step-title">
                            {{ l10nKeys.deployRegisterStepTitle | vtranslate }}
                        </p>
                    </div>
                    <div class="connect-on-prem-modal__step-content">
                        {{ l10nKeys.deployRegisterStepDescription | vtranslate }}
                        <a
                            (click)="handleExternalLinkClick($event, aviLoadBalancerLicensingKbUrl)"
                            class="connect-on-prem-modal__step-link"
                        >
                            <span class="connect-on-prem-modal__step-link-text">
                                {{ l10nKeys.deployingLicenseHubKbLinkLabel | vtranslate }}
                            </span>
                            <cds-icon
                                shape="pop-out"
                                size="16"
                            ></cds-icon>
                        </a>
                    </div>
                    <div class="connect-on-prem-modal__step-content">
                        {{ l10nKeys.registerLicenseHubDescription | vtranslate }}
                        <a
                            (click)="handleExternalLinkClick($event, aviLoadBalancerLicensingKbUrl)"
                            class="connect-on-prem-modal__step-link"
                        >
                            <span class="connect-on-prem-modal__step-link-text">
                                {{ l10nKeys.registeringLicenseHubKbLinkLabel | vtranslate }}
                            </span>
                            <cds-icon
                                shape="pop-out"
                                size="16"
                            ></cds-icon>
                        </a>
                    </div>
                </div>

                <!-- Step 2: Licenses -->
                <div class="connect-on-prem-modal__step">
                    <div class="connect-on-prem-modal__step-header">
                        <div class="connect-on-prem-modal__step-icon-wrapper">
                            <div class="connect-on-prem-modal__step-icon-line connect-on-prem-modal__step-icon-line--left">
                            </div>
                            <div class="connect-on-prem-modal__step-icon">
                                <img
                                    src="src/img/licensing/key-refresh.svg"
                                    alt="{{ l10nKeys.licensesStepTitle | vtranslate }}"
                                    class="connect-on-prem-modal__image"
                                />
                            </div>
                            <div class="connect-on-prem-modal__step-icon-line connect-on-prem-modal__step-icon-line--right"></div>
                        </div>
                        <p class="connect-on-prem-modal__step-title">
                            {{ l10nKeys.licensesStepTitle | vtranslate }}
                        </p>
                    </div>
                    <div class="connect-on-prem-modal__step-content">
                        {{ l10nKeys.viewLicensesManageDescription | vtranslate }}
                        <a
                            (click)="handleExternalLinkClick($event, pulseLicensesUrl)"
                            class="connect-on-prem-modal__step-link"
                        >
                            {{ l10nKeys.pulseLicensesLinkLabel | vtranslate }}
                            <cds-icon
                                shape="pop-out"
                                size="16"
                            ></cds-icon>
                        </a>
                        <p>
                            {{ l10nKeys.manageLicenseDescription | vtranslate }}
                        </p>
                        <a
                            (click)="handleExternalLinkClick($event, broadcomEntitlementsUrl)"
                            class="connect-on-prem-modal__step-link"
                        >
                            {{ l10nKeys.broadcomEntitlementsLinkLabel | vtranslate }}
                            <cds-icon
                                shape="pop-out"
                                size="16"
                            ></cds-icon>
                        </a>
                    </div>
                </div>

                <!-- Step 3: Endpoint Management -->
                <div class="connect-on-prem-modal__step">
                    <div class="connect-on-prem-modal__step-header">
                        <div class="connect-on-prem-modal__step-icon-wrapper">
                            <div class="connect-on-prem-modal__step-icon-line connect-on-prem-modal__step-icon-line--left"></div>
                            <div class="connect-on-prem-modal__step-icon">
                                <img
                                    src="src/img/licensing/blocks-group.svg"
                                    alt="{{ l10nKeys.endpointManagementStepTitle | vtranslate }}"
                                    class="connect-on-prem-modal__image"
                                />
                            </div>
                            <div class="connect-on-prem-modal__step-icon-line connect-on-prem-modal__step-icon-line--right"></div>
                        </div>
                        <p class="connect-on-prem-modal__step-title">
                            {{ l10nKeys.endpointManagementStepTitle | vtranslate }}
                        </p>
                    </div>
                    <div class="connect-on-prem-modal__step-content">
                        {{ l10nKeys.endpointManagementStepDescription | vtranslate }}
                        <a
                            (click)="handleExternalLinkClick($event, aviLoadBalancerLicensingKbUrl)"
                            class="connect-on-prem-modal__step-link"
                        >
                            {{ l10nKeys.endpointManagementKbLinkLabel | vtranslate }}
                            <cds-icon
                                shape="pop-out"
                                size="16"
                            ></cds-icon>
                        </a>
                    </div>
                </div>

                <!-- Step 4: Usage Reporting and License Refresh -->
                <div class="connect-on-prem-modal__step">
                    <div class="connect-on-prem-modal__step-header">
                        <div class="connect-on-prem-modal__step-icon-wrapper">
                            <div class="connect-on-prem-modal__step-icon-line connect-on-prem-modal__step-icon-line--left">
                            </div>
                            <div class="connect-on-prem-modal__step-icon">
                                <img
                                    id="user-report-license-refresh-preview-image"
                                    src="src/img/licensing/certificate-refresh.svg"
                                    alt="{{ l10nKeys.usageReportingStepTitle | vtranslate }}"
                                    class="connect-on-prem-modal__image"
                                />
                            </div>
                        </div>
                        <p class="connect-on-prem-modal__step-title">
                            {{ l10nKeys.usageReportingStepTitle | vtranslate }}
                        </p>
                    </div>
                    <div class="connect-on-prem-modal__step-content">
                        {{ l10nKeys.usageReportingStepDescription | vtranslate }}
                        <a
                            (click)="handleExternalLinkClick($event, aviLoadBalancerLicensingKbUrl)"
                            class="connect-on-prem-modal__step-link"
                        >
                            {{ l10nKeys.usageReportingKbLinkLabel | vtranslate }}
                            <cds-icon
                                shape="pop-out"
                                size="16"
                            ></cds-icon>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>

    <ng-container ngProjectAs="avi-confirmation_modal-actions">
        <cds-button
            (click)="handleClose()"
            (keyup)="handleClose()"
            (keypress)="handleClose()"
            (keydown)="handleClose()"
            status="primary"
            size="md"
        >
            {{ l10nKeys.closeButtonLabel | vtranslate }}
        </cds-button>
    </ng-container>
</avi-confirmation>
